import Vue from 'vue';
import { SEARCH, HTTP } from '@/utils/http';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

const getters = {
  [getterTypes.GET_SPEAKER]: state => state.speaker,
  [getterTypes.GET_SPEAKERS]: state => state.speakers,
  [getterTypes.GET_SPEAKERS_PAGINATION]: state => state.pagination,
};

const actions = {
  async [actionTypes.DO_GET_SPEAKER]({ commit }, payload) {
    const { id, ...params } = payload;
    const { data } = await HTTP.get(`/speakers/${id}`, { params });
    commit(mutationTypes.SET_SPEAKER, data.data.speakers[0]);
    return data;
  },
  async [actionTypes.DO_GET_SPEAKERS]({ commit }, payload) {
    const { method, ...params } = payload;
    const { data } = await SEARCH.post('/doxa_speakers/_search', params);
    if (data.hits.total > 0) {
      const mutation = method === 'append' ? mutationTypes.APPEND_SPEAKERS : mutationTypes.SET_SPEAKERS;
      commit(mutation, data.hits.hits.map(h => h._source));
      return data;
    }
    commit(mutationTypes.SET_SPEAKERS, []);
    return data;
  },
};

const mutations = {
  [mutationTypes.APPEND_SPEAKERS](state, speakers) {
    state.speakers = state.speakers.concat(speakers);
  },
  [mutationTypes.SET_SPEAKER](state, speaker) {
    state.speaker = speaker;
  },
  [mutationTypes.SET_SPEAKERS](state, speakers) {
    state.speakers = speakers;
  },
  [mutationTypes.SET_SPEAKERS_PAGINATION_FIELD](state, payload) {
    Vue.set(state.pagination, payload.key, payload.val);
  },
};

export default {
  state: {
    speaker: {},
    speakers: [],
    pagination: {
      page: 1,
      per: 12,
      total: 0,
    },
  },
  getters,
  actions,
  mutations,
};
